import {
  faChevronsLeft,
  faChevronsRight
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement, ReactNode } from 'react'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { extendTrigger } from '~/components/Layout/GlobalMenu/GlobalMenu.css'
import {
  contextCollapseRow,
  contextHeader,
  contextScrollArea,
  contextWrapper
} from './MessagingContext.css'

/** Right column of the messaging page: collapse control, identity header, scrollable body */
export const MessagingContextPanel = ({
  collapsed = false,
  loading = false,
  onToggle,
  header,
  children
}: {
  collapsed?: boolean
  loading?: boolean
  onToggle?: () => void
  header?: ReactNode
  children?: ReactNode
}): ReactElement => (
  <div className={contextWrapper}>
    <div className={contextCollapseRow}>
      <button
        type="button"
        className={extendTrigger}
        onClick={onToggle}
        aria-label={collapsed ? 'Afficher la fiche' : 'Réduire la fiche'}
      >
        <FontAwesomeIcon icon={collapsed ? faChevronsLeft : faChevronsRight} />
      </button>
    </div>
    {!collapsed && (loading || header !== undefined) && (
      <div className={contextHeader}>
        {loading ? (
          <>
            <Shimmer height={56} width={56} />
            <Shimmer height={16} width={120} />
          </>
        ) : (
          header
        )}
      </div>
    )}
    {!collapsed && !loading && children && (
      <div className={contextScrollArea}>{children}</div>
    )}
  </div>
)
